import React from 'react'
import {
  useDataGrid,
  EditButton,
  ShowButton,
  DeleteButton,
  List,
  EmailField,
} from '@refinedev/mui'
import { DataGrid, GridColDef } from '@mui/x-data-grid'

export const UsersList = () => {
  const { dataGridProps } = useDataGrid()

  const columns = React.useMemo<GridColDef[]>(
    () => [
      {
        field: 'first_name',
        flex: 1,
        headerName: 'First Name',
        minWidth: 200,
      },
      {
        field: 'last_name',
        flex: 1,
        headerName: 'Last Name',
        minWidth: 200,
      },
      {
        field: 'email',
        flex: 1,
        headerName: 'Email',
        minWidth: 250,
        renderCell: function render({ value }) {
          return <EmailField value={value} />
        },
      },
      {
        field: 'role',
        flex: 1,
        headerName: 'Role',
        minWidth: 150,
      },
      {
        field: 'actions',
        headerName: 'Actions',
        sortable: false,
        renderCell: function render({ row }) {
          return (
            <>
              <ShowButton hideText recordItemId={row.uuid} />
              <EditButton hideText recordItemId={row.uuid} />
            </>
          )
        },
        align: 'center',
        headerAlign: 'center',
        minWidth: 80,
      },
    ],
    []
  )

  return (
    <List>
      <DataGrid
        {...dataGridProps}
        columns={columns}
        autoHeight
        getRowId={(row) => row.uuid}
      />
    </List>
  )
}
